import React from "react";

interface DialogCancelProps {
    children?: any,
    text?: string,
    icon?: string,
    left?: boolean,
    hidden?: boolean,
    disabled?: boolean,
    tooltip?: string,
    onClick?: Function
};

class DialogCancel extends React.Component<DialogCancelProps> {

    onClick(event) {
        this.props.onClick(event);
    }
    
    render() {

        return (
        <button className={`dialog-close no-image${this.props.left ? " left" : ""}`}
                style={{ display: this.props.hidden === true ? "none" : "initial" }}
                disabled={this.props.disabled}
                data-tip={this.props.tooltip}
                onClick={ev => this.onClick(ev)}>
            {this.props.icon && <i>{this.props.icon}</i>}
            <span>{this.props.text ?? "Cancel"}</span>
        </button>
        );

    }

}

export default DialogCancel;